module.exports = __webpack_public_path__ + "img/kids-5.80fc533f.jpg";